import { Injectable } from '@angular/core';
enum localstoragetype {
  'cookingStoryUpdatedAt',
}
type localstorageNames = 'cookingStoryUpdatedAt';

@Injectable({
  providedIn: 'root',
})
export class IndexdbLastupdateService {
  constructor() {}

  createCookingStory() {
    let date = localStorage.getItem(localstoragetype[0]);
    if (!date) {
      this.setCookingStoryItem(0);
    }
  }
  updateCookingStory(time: number) {
    if (time == 0) {
      this.setCookingStoryItem(0);
    } else {
      const date = new Date(time);
      this.setCookingStoryItem(date.getTime());
    }
  }
  setCookingStoryItem(data: number | Date) {
    localStorage.setItem(localstoragetype[0], data.toString());
  }
  chekForUpdate(type: localstorageNames): boolean {
    let item = localStorage.getItem(type);
    if (item) {
      const date = JSON.parse(item) as number;
      const now = Date.now();
      if (date == 0) return true;
      if (date < now) return true;
      if (date > now) return false;
    }
  }
  getNextDayTime(): number {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 1, 0);
    return tomorrow.getTime();
  }
  initial() {
    this.createCookingStory();
  }
}
